import { render, staticRenderFns } from "./ListarSucursales.vue?vue&type=template&id=b0a079c4&"
import script from "./ListarSucursales.vue?vue&type=script&lang=js&"
export * from "./ListarSucursales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports